import useProject from 'hooks/useProject';
import MainLayout from 'layouts/MainLayout';
import { Link, useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import OrganizerProjectItemList from './project-item';
import { ProjectChart, ProjectSelectedCompany } from 'pages/admin/project/detail';

const OrganizerProjectDetail = () => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId');

  const { useGetProject } = useProject();
  const { projectInfo } = useGetProject(projectId);

  if (!projectInfo) return;

  return (
    <MainLayout>
      <div className="page-header">프로젝트 상세</div>
      <div className="page-card">
        <div className="table-search-wrap detail-form-wrap">
          <div>
            <label>프로젝트명</label>
            <p className="text">{projectInfo.name}</p>
          </div>
          <div>
            <label>발주처</label>
            <p className="text">{projectInfo.orderer}</p>
          </div>
          <div>
            <label>수행연도</label>
            <p className="text">{projectInfo.executionYear}</p>
          </div>
          <div />
          <div>
            <label>시작일</label>
            <p className="text">{projectInfo.startAt}</p>
          </div>
          <div>
            <label>종료일</label>
            <p className="text">{projectInfo.endAt}</p>
          </div>
          <div>
            <label>등록일시</label>
            <p className="text">{format(projectInfo.createdAt, 'yyyy-MM-dd HH:mm:ss')}</p>
          </div>
        </div>
      </div>
      <br />
      <Link to={'/organizer/project'}>
        <button className="btn success-btn" type="button">
          프로젝트 목록
        </button>
      </Link>
      <br />
      <br />
      <ProjectChart statsData={projectInfo.statsData} />
      <br />
      <ProjectSelectedCompany projectId={projectId} />
      <br />
      <OrganizerProjectItemList projectId={projectId} />
    </MainLayout>
  );
};

export default OrganizerProjectDetail;
